// extracted by mini-css-extract-plugin
export default {"container":"TaskHeader_container__dy+zA","task":"TaskHeader_task__PTByW","subtext":"TaskHeader_subtext__3YIri"};